import type { SchemaOf } from '../helpers';
import { Joi, objectSchemaOf } from '../helpers';
import type { RevisionGlobal, IDeepPartialBaseConfig } from './configModel';
import {
  revisionGlobalSchema,
  partialBaseConfigSchemaMap,
} from './configModel';

export interface IUpdateParams {
  configId: 'DEFAULT' | string;
  revision: RevisionGlobal;
  config: IDeepPartialBaseConfig;
  override?: boolean;
}

export const updateParamsSchemaMap: SchemaOf<IUpdateParams> = {
  configId: Joi.string().required(),
  revision: revisionGlobalSchema.required(),
  config: Joi.object(partialBaseConfigSchemaMap).required(),
  override: Joi.boolean().optional(),
};

export const updateParamsSchema = objectSchemaOf<IUpdateParams>(
  updateParamsSchemaMap
);
